import type { IRelatedItem } from './IRelatedItem';
import { matchesFilter } from './matchesFilter';

/**
 * Записи картки «Пов’язані записи» (прототип v4 relSecs): зв'язані записи й ті, що посилаються на запис полем (без повторів), за фільтром
 * секції (значення — з самого запису або з `values`; поки значення читаються — `pending` — такі записи не показуються) і за номером, як
 * таблиця модуля прототипу. `reverseTotal` — скільки всього записів посилаються полем (показано може бути менше); без фільтра кількість
 * враховує й непоказані. Чиста функція.
 */
export function relatedItemsOf(linked: readonly IRelatedItem[], reverse: readonly IRelatedItem[], reverseTotal: number, filter: string,
  values: ReadonlyMap<string, Readonly<Record<string, unknown>>>, pending: boolean): { items: IRelatedItem[]; total: number } {
  const ids = new Set(linked.map((i) => i.id));
  const extra = reverse.filter((r) => !ids.has(r.id));
  const all = [...linked, ...extra];
  const kept = !filter ? all : all.filter((i) => {
    const own = i.values ?? values.get(i.id);
    if (!own && pending) return false;
    return matchesFilter(own ?? {}, filter);
  });
  const items = [...kept].sort((a, b) => (a.code || Number.MAX_SAFE_INTEGER) - (b.code || Number.MAX_SAFE_INTEGER));
  const total = filter ? items.length : linked.length + Math.max(reverseTotal, reverse.length) - (reverse.length - extra.length);
  return { items, total };
}
